import { useWindowSize } from "./useWindowSize";
import { SizeClassComparer } from "./SizeClassComparer";
import { useMemo } from "react";

export const useWindowWidthComparer = () : SizeClassComparer => {
  const {windowWidth} = useWindowSize();
  return useMemo( () => new SizeClassComparer(windowWidth), [windowWidth]);
}
